import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import windowSize from "../libs/reactWindowSize";
import { withScenePosition } from "../scenePosition";
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';

class DragDrop extends Component {

  constructor(props){
    super(props);

    this.state = {
      isSwapped: false,
      heldItem: null,
      items: [0,1]
    }

    this.onSortStart = this.onSortStart.bind(this);
    this.onSortEnd = this.onSortEnd.bind(this);
  }

  getBackgroundImagePath(filename) {
    return `${window.public_url}/images/scenes/drag-drop/${filename}`
  }

  onSortStart(sortData, e) {
    e.preventDefault();
  };

  onSortEnd(indexes) {
    this.setState({
      items: arrayMove(this.state.items, indexes.oldIndex, indexes.newIndex),
      isSwapped: indexes.oldIndex !== indexes.newIndex ? !this.state.isSwapped : this.state.isSwapped,
      heldItem: null
    });
  };

  render() {

    const { left, top, width, height, hover1Img, hover2Img, drop1Img, drop2Img, afterImg, itemWidth1, itemWidth2 } = this.props;
    const { items } = this.state;
    const itemsData = [{
      hoverImg: hover1Img,
      dropImg: drop1Img,
      itemWidth: itemWidth1
    }, {
      hoverImg: hover2Img,
      dropImg: drop2Img,
      itemWidth: itemWidth2
    }];

    const SortableItem = SortableElement(({hoverImg, dropImg, itemWidth, itemClass}) =>
      <li className={itemClass} style={{width: itemWidth}}>
        <img className="hover-img" alt="hover" src={this.getBackgroundImagePath(hoverImg)} />
        <img className="drop-img" alt="drop" src={this.getBackgroundImagePath(dropImg)} />
      </li>
    );

    const SortableList = SortableContainer(({items}) => {
      return (
        <ul className="dragdrop-list">
          {items.map((value, index) => (
            <SortableItem key={`item-${index}`} index={index} hoverImg={itemsData[value].hoverImg} dropImg={itemsData[value].dropImg} itemWidth={itemsData[value].itemWidth} itemClass={index === this.state.heldItem ? "sortable-item is-held" : "sortable-item"} />
          ))}
        </ul>
      );
    });

    return (
      <Fragment>
        { this.state.isSwapped &&
          <img className="step-background" alt="background" src={this.getBackgroundImagePath(afterImg)} />
        }
        <div className="dragdrop" style={{top: top, left: left, width: width, height: height}}>
          <SortableList
            items={items}
            axis="x"
            onSortStart={this.onSortStart}
            onSortEnd={this.onSortEnd}
            helperClass="active-sort-held"
          >
          </SortableList>
        </div>
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step,
    minitourState: state.minitour
  }
}

export default windowSize(connect(mapStateToProps)(withScenePosition(DragDrop)));



// WEBPACK FOOTER //
// ./src/components/DragDrop.jsx